import { RugbyUnionEventStatusId } from '@collector/sportsapi-client-legacy'

import { PitchBlockedEventStatus } from '../../../configuration'

export const pitchBlockedEventStatus: PitchBlockedEventStatus<RugbyUnionEventStatusId> =
  new Set([
    RugbyUnionEventStatusId.Abandoned,
    RugbyUnionEventStatusId.Cancelled,
    RugbyUnionEventStatusId.NotStarted,
    RugbyUnionEventStatusId.StartDelayed,
    RugbyUnionEventStatusId.Postponed,
    RugbyUnionEventStatusId.Interrupted,
    RugbyUnionEventStatusId.ToFinish,
    RugbyUnionEventStatusId.FinishedAwardedWin,
    RugbyUnionEventStatusId.FinishedRegularTime,
    RugbyUnionEventStatusId.FinishedAfterExtratime,
    RugbyUnionEventStatusId.FinishedAfterPenalties,
    RugbyUnionEventStatusId.Halftime,
    RugbyUnionEventStatusId.ExtratimeHalftime,
    RugbyUnionEventStatusId.WaitingForExtratime,
    RugbyUnionEventStatusId.WaitingForPenalty,
    RugbyUnionEventStatusId.Penalties,
  ])
